import React from 'react'
import ModalButtons from "../ModalButtons/ModalButtons"
import Tabs from '../Tabs/Tabs'
import HousekeepingTypeBuilderTabContent from "./HousekeepingTypeBuilderTabContent"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import HousekeepingTypeBuilderErrors from "./HousekeepingTypeBuilderErrors";

class HousekeepingTypeBuilder extends React.Component {

	constructor(props) {
		super(props);

    this.state = {
      housekeeping_type: this.props.housekeeping_type || [],
      new_record: this.props.new_record,
      housekeeping_type_create_path: this.props.housekeeping_type_create_path,
      housekeeping_type_save_path: this.props.housekeeping_type_save_path,
      errors: this.props.errors ? this.props.errors : {},
    };
    this.state.active_tab = 'general';
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChangeField = this.onChangeField.bind(this);
    this.onChangeDescription = this.onChangeDescription.bind(this);
    this.onChangeRoomType = this.onChangeRoomType.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
		
	}

  /*******************
  * Render functions *
  ********************/

	render() {
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: ['data-dismiss="modal"']
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: this.onSubmit,
      },
    ]

		return (
			<div className="HousekeepingTypeBuilder" ref="root">
        <Tabs tabs={this.Tabs()} displayErrorMessage={HousekeepingTypeBuilderErrors.general(this.state.errors).length ? true : false}/>
				<div className="panel panel-form">
  				<ModalButtons loading={this.state.loading} buttons={buttons} />
          <HousekeepingTypeBuilderTabContent   {...this.state} onChangeField={this.onChangeField} onChangeDescription={this.onChangeDescription} onChangeRoomType={this.onChangeRoomType}/>
  			  <LoadingSpinner show={this.state.loading} />
        </div>
			</div>
		);
  };

  Tabs() {
    return (
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
      ]
    );
  };
  
  onSubmit() {
    var self = this
    self.setState({ loading: true })
    setTimeout(function () {
      $.ajax({
        type: self.state.new_record ? 'POST' : 'PATCH',
        url: self.state.new_record ? self.state.housekeeping_type_create_path : self.state.housekeeping_type_save_path,
        data: {
          housekeeping_type: self.state.housekeeping_type
        }
      }).done(function (data) {
        if (Object.keys(data.errors).length) {
          self.setState({
            errors: {
              field_errors: data.errors,
              header_errors: data.header_errors
            },
            loading: false
          })
        }
        else {
          if (parent && parent.refresh_data) {
            if (self.props.new_record == true) {
              parent.refresh_data(I18n.t('housekeeping_type_created_successfully'));
            } else {
              parent.refresh_data(I18n.t('housekeeping_type_saved_successfully'));
            }
          }
          if (parent && parent.hide_modal) {
            parent.hide_modal()
          }
        }
      })
    }, 1000)
  }


  /******************
  * Change handlers *
  *******************/

  onChangeActiveTab(active_tab, event) {
    event.stopPropagation();
    event.preventDefault();
    this.setState({active_tab: active_tab});
  }

  onChangeField(event) {
    var housekeeping_type = { ...this.state.housekeeping_type }
    housekeeping_type[event.target.name] = event.target.value
    this.setState({
      housekeeping_type: housekeeping_type
    })
  }

  onChangeDescription(description) {
    var housekeeping_type = { ...this.state.housekeeping_type }
    housekeeping_type["description"] = description
    this.setState({
      housekeeping_type: housekeeping_type
    })
  }

  onChangeRoomType(room_type_ids) {
    var housekeeping_type = { ...this.state.housekeeping_type }
    housekeeping_type.room_type_ids = room_type_ids
    this.setState({ housekeeping_type: housekeeping_type })
  }


}

export default HousekeepingTypeBuilder